<template>
<div id="spaceloading">    
    <div class="ttl-cloud-info">
        <div class="ttl-cloud-info-header">
            <img :src="require('@/assets/icon/icloud.png')" />
            <div class="ttl-nums">{{diskdata.applyspace}} / {{diskdata.totalspace}}</div>
            <div class="ttl-percent">{{diskdata.percent+'%'}}</div>
        </div>
        <div class="ttl-percent-line top10">
        <div class="ttl-percent-select" :style="'width:'+diskdata.percent+'%'" />
        </div>
        <div class="notice-content top10" v-if="diskdata.isnotice">{{diskdata.noticemsg}}</div>
    </div>
</div>

<!-- 图片信息列表 -->
<!-- <div class="TTL-table top40" id="table-disk-photo-obj">
    <div class="TTL-space-list">
        <div class="TTL-space-info" v-for="(item,index) in list" :key="index">
            <wcimage :option="{size:'middle'}" :value="item.thumb" :list="thumblist" />
            <span class="TTL-space-time">{{item.inputtime}}</span>
        </div>
    </div>
    <div class="TTL-page-box top70">
        <div class="TTL-page-box-in">
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetPhotolists();
                    }"
                />
            </div>
        </div>
    </div>
</div> -->

</template>


<script>
import INTERFACE_MODEL_SPACE from '@/Interface/Shop/space';
export default {
    components: {},
    data() {
        return {
            diskdata: {
                totalspace:'',  //总空间容量
                applyspace:'',  //使用容量
                percent:'',     //百分比占比
                isnotice:false, //是否空间不足报警提示
                noticemsg:'',   //空间不足报警提示名称
            },

            param: {
                p:1,
                rollpage:30,
                rows:0,
            },
            list:[],
            thumblist:[],
            
        }
    },

    mounted() {
        this.OnloadMethod();
    },

    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetSpaceInfos(); //获取小程序详细信息设置
            // this.GetPhotolists(); //获取相册信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.GetSpaceInfos(); //获取小程序详细信息设置
                // this.GetPhotolists(); //获取相册信息列表

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetPhotolists(); //获取相册信息列表
            }
        },
        


        /////////////////////////////////////////
        /////////////////////////////////////////
        //基础操作
        
        //获取硬盘数据信息
        GetSpaceInfos() {
            //loading等待动画加载
            var obj=document.getElementById("spaceloading");
            this.$loading.openloading(obj);

            INTERFACE_MODEL_SPACE.GET_SPACE_INFO().then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 var data=res.data;
                 this.diskdata.totalspace=data.totalspace;
                 this.diskdata.applyspace=data.applyspace;
                 this.diskdata.percent=data.percent;
                 this.diskdata.isnotice=data.isnotice;
                 this.diskdata.noticemsg=data.noticemsg;
            });
        },


        //获取空间相册列表
        GetPhotolists() {
            INTERFACE_MODEL_SPACE.GET_SPACE_PHOTO(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.list=res.data.list;
                 this.param.rows=res.data.count;
                 
                 this.thumblist=[];
                 for(var i in this.list) this.thumblist.push(this.list[i].base);
            });
        },
        
        

    },

}
</script>
<style lang="scss" Scoped>
.ttl-cloud-info {display: inline-block;width:40%;margin:40px 0 0 20px;position:relative;}
.ttl-cloud-info-header {display: inline-flex;align-items: center;}
.ttl-cloud-info-header img {width:40px;}
.ttl-nums {font-size:14px;color:#333333;font-weight: 650;margin-left:15px;}
.ttl-percent {font-size:13px;position:absolute;right:0;}
.ttl-percent-line {display:inline-block;width:100%;background-color: #dddddd;height: 20px;border-radius: 10px;}
.ttl-percent-select {display: inline-block;width:100%;height: 20px;border-radius: 10px;transition: .3s width;background:linear-gradient(to right,#5650DE, #F869D5);}
.ttl-percent-select-warning {display: inline-block;width:100%;height: 20px;border-radius: 10px;transition: .3s width;background:#f11b3f;}
.notice-content {font-size:12px;color:#f11b3f;line-height: 23px;letter-spacing: 1px;}
.TTL-space-list {display:inline-block;width:100%;}
.TTL-space-info {display:inline-block;margin:35px 35px 0 0;cursor: pointer;text-align: center;}
.TTL-space-time {display: inline-block;width:100%;text-align: center;font-size:12px;}
</style>